module.exports = global["Components"] = require("-!/home/vsts/work/1/s/AFGruppen.Web/Frontend/mockup/node_modules/babel-loader/lib/index.js!./components.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Components!./src/components.js
// module id = 674
// module chunks = 0